import React, { useEffect, useRef } from 'react';
import Guides from '@scena/react-guides';

import { RulerWrapper } from './styles';

const Ruler = props => {
  let { rulerType, ppi, rulerWidth, rulerHeight, scaling, backgroundColor = '#FFFFFF', guides = [], onChangeGuides = () => {} } = props;
  const guideRef = useRef(undefined);
  ppi = 96;

  useEffect(() => {
    if (guideRef && guides.length > 0) {
      const onDragStart = guideRef.current.onDragStart;
      guideRef.current.onDragStart = (e) => {
        if (e.datas.target.className.includes('scena-adder')) {
          return false;
        }
        onDragStart(e);
      };
      guideRef.current.loadGuides(guides);
    }
  }, [guides]);

  return (
    <RulerWrapper className={`ruler-${rulerType}`}>
      <Guides
        ref={guideRef}
        zoom={(ppi * scaling) / 25.4}
        width={rulerWidth * scaling}
        height={rulerHeight * scaling}
        unit={scaling < 1 ? Number.parseFloat(1 - scaling).toFixed(1) * 50 + 10 : 10}
        type={rulerType}
        direction="start"
        snapThreshold={0}
        snaps={[100, 200, 300]}
        backgroundColor={backgroundColor}
        textColor="#000000"
        className="ruler-guideliness"
        displayDragPos={true}
        dragPosFormat={position => {
          return `${position}mm`;
        }}
        onChangeGuides={({ guides }) => {
          onChangeGuides(guides);
        }}
      />
    </RulerWrapper>
  );
};

export default React.memo(Ruler);
